import * as React from "react";
import ReactTooltip from "react-tooltip";
import { useEventListener } from "./useEventListener.hook";

export function useFeedbackForm(tooltipInstance: any) {
    const [isMobileView, setMobileView] = React.useState(false);

    React.useLayoutEffect(() => {
        function updateSize() {
            setMobileView(window.innerWidth <= 639);
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    React.useEffect(() => {
        ReactTooltip.rebuild();
    }, [isMobileView]);

    const handler = React.useCallback((e: any) => {
        if (e.key === "Escape") {
            ReactTooltip.hide(tooltipInstance);
        }
    }, []);

    useEventListener("keydown", handler);

    return [isMobileView];
}